import BranchInventory from "./branch-inventory.container";

export default BranchInventory;
